// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1tA9O","sidebar":"App_sidebar__2oTEn","content":"App_content__1dlDM"};